'use client';
import { useUserService } from './useUserService';

export const useUser = () => {
  const { useGetCookieUser: useGetUserId } = useUserService();
  const { data: userId } = useGetUserId();
  const isAuthenticated = Boolean(userId);
  return { userId, isAuthenticated };
};
